// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const getTableSettings = (payload = null) => http.post('apiImportTranslationData/getTableSettings', payload).then(getData);

export const get = (payload = null) => http.post('apiImportTranslationData/getRows', payload).then(getData);

export const getRow = (rowID) => http.get(`apiImportTranslationData/getRow&RowID=${rowID}`).then(getData);

export const create = (row) => http.post('apiImportTranslationData/addRow', row).then(getData);

export const remove = (row) => http.post('apiImportTranslationData/deleteRow',row).then(getData);

export const update = (row) => http.post('apiImportTranslationData/editRow',row).then(getData);